import { render, staticRenderFns } from "./sliding.vue?vue&type=template&id=122290e0"
import script from "./sliding.vue?vue&type=script&lang=js"
export * from "./sliding.vue?vue&type=script&lang=js"
import style0 from "./sliding.vue?vue&type=style&index=0&id=122290e0&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports